<ng-container *transloco="let t; prefix: 'driverDocuments'">
@if (isLoading) {
  <div class="d-flex justify-content-center align-items-center spinner-container">
    <span class="spinner-border"></span>
  </div>
}
@if (!isLoading && driverDocuments?.length && hasDrivers()) {
  <div class="documents-container">
    <div class="driver-documents__header">
      <div class="driver-documents__info d-flex flex-column gap-2">
        <span class="driver-documents__title"> {{ t('details.title') }} </span>
      </div>
    </div>
    @for (doc of driverDocuments; track doc) {
      <div class="document-item">
        <div class="document-info">
          <img src="assets/icons/file-pdf.svg" [alt]="t('details.pdfIcon')" class="pdf-icon" />
          <div class="text-content">
            <div class="doc-name">
              <span>{{ doc.documentName | documentTypeLabel }}</span>
            </div>
            @if (doc.validUntil) {
              <div class="doc-validity">
                <span class="valid-until">{{ t('details.validUntil', { date: (doc.validUntil | date: 'yyyy/MM/dd') }) }}</span>
              </div>
            }
          </div>
          @if (doc.validUntil) {
            <div class="doc-expiry">
              @if (isDocumentExpired(doc.validUntil)) {
                <span class="expired-badge" [ngbTooltip]="documentNotificationMessage">{{ t('status.expired') }}</span>
              }
              @if (isDocumentExpiringSoon(doc.validUntil)) {
                <span class="expiring-soon-badge" [ngbTooltip]="documentNotificationMessage">{{ t('status.expiringSoon') }}</span>
              }
            </div>
          }
          @if (doc.documentName === 'Drivers License' && doc.pdpValidUntil) {
            <div class="pdp">
              <div class="text-content">
                <div class="doc-name"> {{ t('details.pdp') }} </div>
                <div class="doc-validity">
                  <span class="valid-until">{{ t('details.validUntil', { date: (doc.pdpValidUntil | date: 'yyyy/MM/dd') }) }}</span>
                </div>
              </div>
              <div class="doc-expir pdp__doc-expiry">
                @if (isDocumentExpired(doc.pdpValidUntil)) {
                  <span class="expired-badge" [ngbTooltip]="documentNotificationMessage">{{ t('status.expired') }}</span>
                }
                @if (isDocumentExpiringSoon(doc.pdpValidUntil)) {
                  <span class="expiring-soon-badge" [ngbTooltip]="documentNotificationMessage">{{ t('status.expiringSoon') }}</span>
                }
              </div>
            </div>
          }
        </div>
        <div class="document-actions">
          <button class="edit-btn" [title]="t('details.edit')" (click)="openEditDriverDocumentModal(doc)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.00017 21.0001C4.08117 21.0001 4.16217 20.9901 4.24217 20.9701L8.24217 19.9701C8.41817 19.9261 8.57917 19.8351 8.70717 19.7071L21.0002 7.41411C21.3782 7.03611 21.5862 6.53411 21.5862 6.00011C21.5862 5.46611 21.3782 4.96411 21.0002 4.58611L19.4142 3.00011C18.6582 2.24411 17.3422 2.24411 16.5862 3.00011L4.29317 15.2931C4.16517 15.4211 4.07417 15.5821 4.03017 15.7571L3.03017 19.7571C2.94417 20.0981 3.04517 20.4581 3.29317 20.7071C3.48217 20.8971 3.73817 21.0001 4.00017 21.0001ZM18.0002 4.41411L19.5862 6.00011L18.0002 7.58611L16.4142 6.00011L18.0002 4.41411ZM5.90317 16.5111L15.0002 7.41411L16.5862 9.00011L7.48817 18.0971L5.37417 18.6251L5.90317 16.5111Z" fill="#9FA1A4"/>
            </svg>
          </button>
          <button class="download-btn" [title]="t('details.download')" (click)="downloadDocument(doc)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 16L16 11H13V4H11V11H8L12 16Z" fill="#9FA1A4"/>
              <path d="M20 18H4V11H2V18C2 19.103 2.897 20 4 20H20C21.103 20 22 19.103 22 18V11H20V18Z" fill="#9FA1A4"/>
            </svg>
          </button>
          <button class="delete-btn" [title]="t('details.delete')" (click)="openDeleteDriverDocumentConfirmationModal(doc)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 20C5 21.103 5.897 22 7 22H17C18.103 22 19 21.103 19 20V8H21V6H18H17V4C17 2.897 16.103 2 15 2H9C7.897 2 7 2.897 7 4V6H6H3V8H5V20ZM9 4H15V6H9V4ZM8 8H16H17L17.001 20H7V8H8Z" fill="#9FA1A4"/>
              <path d="M9 10H11V18H9V10ZM13 10H15V18H13V10Z" fill="#9FA1A4"/>
            </svg>
          </button>
        </div>
      </div>
    }
  </div>
}
@if (!isLoading && !driverDocuments?.length && hasDrivers()) {
  <div class="d-flex no-documents-container">
    <div class="no-documents-icon">
      <img src="assets\icons\exclamation_circle.svg" alt="no-documents-image">
    </div>
    <p class="no-documents-message">{{ t('details.noDocuments') }}</p>
  </div>
}

@if (!isLoading && hasDrivers()) {
  <div class="upload-actions">
    <div class="upload-actions__wrapper d-flex flex-wrap align-items-center justify-content-between gap-3">
      <!-- Left info -->
      <span class="upload-hint-text">{{ t('details.filesSupported') }}</span>
      <!-- Center upload button -->
      <div class="upload-btn-wrapper">
        <button class="upload-documents-btn" (click)="openUploadDriverDocumentModal()">
          {{ t('upload.title') }}
        </button>
      </div>
      <!-- Right info -->
      <span class="upload-hint-text">{{ t('details.maxFileSize') }}</span>
    </div>
  </div>
}